<div class="popup-form wf-section">
  <button class="closedialog close-signuponly" (click)="closeDialog()">
    <i class="material-icons">close</i>
  </button>
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div>
        <h2 class="hero-title _50px">
          Create
          <span class="add-scribble-below">Account</span><br>
        </h2>

      </div>
    </div>
    <div class="margin-50px">
      <div class="w-form">
        <form [formGroup]="signUpForm" (ngSubmit)="onSubmit(signUpForm)" id="signup-form" name="signup-form" data-name="Sign up form" class="form schelude">
          <div class="row">
            <div class="col-sm-6">
              <input formControlName="FirstName"
                     id="FirstName"
                     type="text"
                     class="text-field margin-bottom w-node-_6bc99137-51a2-55f9-ea62-62292b9d471d-d5529654 w-input"
                     maxlength="25"
                     name="FirstName"
                     data-name="FirstName"
                     placeholder="Enter your first name"
                     required="">

              <div *ngIf="!f.FirstName.valid && f.FirstName.touched && (f.FirstName.pristine || f.FirstName.dirty)" class="error-message">
                <div>First name is required.</div>
              </div>
            </div>
            <div class="col-sm-6">
              <input formControlName="LastName"
                     id="LastName"
                     type="text"
                     class="text-field margin-bottom w-node-_6bc99137-51a2-55f9-ea62-62292b9d471d-d5529654 w-input"
                     maxlength="25"
                     name="LastName"
                     data-name="LastName"
                     placeholder="Enter your last name"
                     required="">

              <div *ngIf="!f.LastName.valid && f.LastName.touched && (f.LastName.pristine || f.LastName.dirty)" class="error-message">
                <div>Last name is required.</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <input formControlName="Email" id="email" (change)="fn_checkUserExist(f.Email.value)"
                     type="email" class="text-field margin-bottom w-node-_5e5718c4-43f4-0d39-a8e5-2db3981574d1-e0529653 w-input"
                     maxlength="256" name="Email" data-name="Email"
                     placeholder="Enter your email"
                     required="">

              <div class="error-message" *ngIf="f.Email.touched && f.Email.invalid && f.Email.pristine">
                <div>Email is required.</div>
              </div>
              <div class="error-message" *ngIf="!f.Email.valid && (!f.Email.hasError('pattern') && f.Email.touched && f.Email.dirty)">
                <div>Email is required.</div>
              </div>
              <div class="error-message" *ngIf="!f.Email.valid && (f.Email.hasError('pattern') && f.Email.dirty)">
                <div>Invalid Email Address</div>
              </div>
            </div>
            <div class="col-sm-6">
              <input formControlName="ContactNo" id="ContactNo"
                     type="text" class="text-field margin-bottom w-node-_5e5718c4-43f4-0d39-a8e5-2db3981574d1-e0529653 w-input"
                     maxlength="10" name="ContactNo" data-name="ContactNo"
                     placeholder="Enter your contact no."
                     required="">

              <div *ngIf="!f.ContactNo.valid && f.ContactNo.touched">
                <div class="error-message" *ngIf="(f.ContactNo.hasError('pattern') || f.ContactNo.hasError('minlength') || f.ContactNo.hasError('maxlength'))
                              && (f.ContactNo.pristine || f.ContactNo.dirty)">
                  <div> Should contain only 10-digit numbers</div>
                </div>
                <div class="error-message" *ngIf="(!f.ContactNo.hasError('pattern') && !f.ContactNo.hasError('minlength') && !f.ContactNo.hasError('maxlength'))
                              && (f.ContactNo.pristine || f.ContactNo.dirty)">
                  <div>Contact No. is required.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <input formControlName="Password" type="password"
                     class="text-field margin-bottom w-input"
                     maxlength="256"
                     name="Password"
                     data-name="Password"
                     placeholder="Password" id="Password">
              <div class="error-message" *ngIf="!f.Password.valid && f.Password.touched && (f.Password.pristine || f.Password.dirty)">
                <div> Minimum 6 characters required</div>
              </div>
            </div>
            <div class="col-sm-6">
              <input formControlName="ConfirmPassword" type="password"
                     class="text-field margin-bottom w-input"
                     maxlength="256"
                     name="ConfirmPassword"
                     data-name="ConfirmPassword"
                     placeholder="Confirm Password"
                     id="ConfirmPassword">
              <div class="error-message" *ngIf="!f.ConfirmPassword.valid && f.ConfirmPassword.touched && (f.ConfirmPassword.pristine || f.ConfirmPassword.dirty)">
                <div>Passwords should match</div>
              </div>
            </div>
          </div>

          <!-- Honeypot field - hidden from real users, bots will fill this -->
          <div style="position: absolute; left: -9999px; opacity: 0; height: 0; overflow: hidden;" aria-hidden="true">
            <label for="website">Website</label>
            <input formControlName="Website"
                   type="text"
                   id="website"
                   name="website"
                   tabindex="-1"
                   autocomplete="off">
          </div>

          <!-- Cloudflare Turnstile -->
          <div class="row margin-bottom" style="margin-bottom: 15px;">
            <div class="col-sm-12">
              <div id="turnstile-container"></div>
              <div class="error-message" *ngIf="captchaError">
                <div>Please verify that you are not a robot.</div>
              </div>
            </div>
          </div>

          <p class="cookies-font check">By signing up you agree to our <a href="/terms-of-use" target="_blank">Terms &amp; Condition</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>.</p><span class="checkbox-label w-form-label">Checkbox</span>

          <div>
            <input cdkFocusInitial [disabled]="signUpForm.invalid"
                   type="submit" value="Submit →"
                   data-wait="Please wait..."
                   class="button subscribe orange full-button w-button">
          </div>



          <div class="margin-20px">
            <p class="cookies-font">
              Already have an account? <a (click)="openLoginWindow()" class="anchor-underline">Sign In</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div><img src="assets/img/scribbles-3.png" width="60" data-w-id="6bc99137-51a2-55f9-ea62-62292b9d4736" sizes="(max-width: 479px) 100vw, (max-width: 991px) 40px, 60px" srcset="assets/img/scribbles-3-p-500.png 500w, assets/img/scribbles-3.png 608w" alt="" class="scribble-2"><img src="assets/img/scribbles-8.png" width="600" data-w-id="6bc99137-51a2-55f9-ea62-62292b9d4737" sizes="(max-width: 767px) 100px, (max-width: 991px) 200px, 400px" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-4">
</div>





